import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import translate from 'components/hoc/translate';
import utils from 'helpers/utils';

const TextFieldWrapper = styled.div`
    margin: 0 0 20px 0;
`;

const Label = styled.div`
    margin-bottom: 3px;
    font-size: 14px;
    line-height: 1.2;
    font-weight: bold;
`;

const Text = styled.div`
    font-size: 16px;
    line-height: 1.2;
`;

const BooleanField = (props) => {
    const {
        label,
        translate,
        value,
    } = props;

    if (utils.isEmpty(value)) {
        return null;
    }

    let translationKey = value ? 'resources.general.fields.boolean.yes' : 'resources.general.fields.boolean.no';

    return (
        <TextFieldWrapper>
            { label &&
                <Label>{ translate(label) || '...' }</Label>
            }

            <Text>{ translate(translationKey) }</Text>
        </TextFieldWrapper>
    );
};

BooleanField.propTypes = {
    label: PropTypes.string,
    translate: PropTypes.func.isRequired,
    value: PropTypes.oneOfType([
        PropTypes.string,
        PropTypes.number,
        PropTypes.bool,
    ]),
};

export default translate(BooleanField);



// WEBPACK FOOTER //
// ./src/components/show/BooleanField.js